import React from 'react';
import ListingCard from './ListingCard';
import { useListingManagement } from './useListingManagement';
import { ListingCardListing, ListingCardType } from './types';

interface MyListingCardProps {
  listing: ListingCardListing;
  type: ListingCardType;
  onOpen: () => void;
  onChanged: () => void;
}

/**
 * One row of the My Listings page: the shared ListingCard plus its owner
 * "manage" menu (Edit / Share / Remove). This wrapper exists because
 * useListingManagement is a hook and can't be called inside MyListings' list
 * .map() — each listing needs its own hook instance, so it gets its own
 * component. `onChanged` re-fetches the list after an edit or removal.
 */
const MyListingCard: React.FC<MyListingCardProps> = ({
  listing,
  type,
  onOpen,
  onChanged,
}) => {
  const manage = useListingManagement(listing, { onChanged });
  return (
    <>
      <ListingCard
        size="small"
        type={type}
        listing={listing}
        hideNewBadge={type === 'seller'}
        compactHeadline={type === 'seller' ? 'address' : 'stats'}
        onOpen={onOpen}
        onEdit={manage.openEdit}
        onDelete={manage.openDelete}
        onShare={manage.openShare}
        isLoggedIn
      />
      {manage.modals}
    </>
  );
};

export default MyListingCard;
